<template>
  <div class="flex text-center items-center justify-center relative mb-5">
    <div
      role="button"
      tabindex="0"
      class="button-select transition-colors text-velux-grey-900  inline-flex w-auto text-base md:text-lg text-center flex-auto items-center justify-center relative py-3.5 md:p-3 px-7 font-bold last:mb-0"
      :class="isActive ? 'border-2 border-velux-red' : 'border border-velux-grey-800'"
    >
      <slot></slot>
    </div>
    <slot name="tooltip" class="ml-4"></slot>
  </div>
</template>

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
@media (hover: hover) {
  .button-select:hover {
    @apply text-velux-white bg-velux-red border-velux-red !important;
  }
}

.button-select:active {
  @apply text-velux-white bg-velux-red border-velux-red !important;
}
</style>
